import { Box, Flex, Text } from "@chakra-ui/react";
import { useState } from "react";
import { FaInbox } from "react-icons/fa";
import { ManagementFunnelCard, ManagementFunnelStageGroup } from "../../../models/Management";
import { crm, Pill } from "../../../theme";
import ProcessCard from "./ProcessCard";

const ProcessColumn = ({
  stage,
  onDragStartCard,
  onDropInColumn,
  onCardClick,
}: {
  stage: ManagementFunnelStageGroup;
  onDragStartCard: (e: React.DragEvent, card: ManagementFunnelCard) => void;
  onDropInColumn: (e: React.DragEvent, stage: ManagementFunnelStageGroup) => void;
  onCardClick: (card: ManagementFunnelCard) => void;
}) => {
  const [isOver, setIsOver] = useState(false);
  const accentColor = stage.color || crm.brand;

  return (
    <Flex
      flexDir="column"
      minW="300px"
      maxW="300px"
      h="100%"
      bg={isOver ? crm.brandSoft : crm.columnBg}
      borderRadius="14px"
      border={isOver ? `2px dashed ${crm.brand}` : "2px solid transparent"}
      transition="background-color .12s ease, border .12s ease"
      overflow="hidden"
      onDragOver={(e) => {
        e.preventDefault();
        setIsOver(true);
      }}
      onDragLeave={() => setIsOver(false)}
      onDrop={(e) => {
        setIsOver(false);
        onDropInColumn(e, stage);
      }}
    >
      <Box h="3px" bg={accentColor} borderRadius="14px 14px 0 0" />

      <Flex align="center" justify="space-between" px="14px" py="10px">
        <Flex align="center" gap="8px">
          <Box w="8px" h="8px" borderRadius="full" bg={accentColor} flexShrink={0} />
          <Text fontWeight="700" fontSize="sm" color={crm.text}>
            {stage.stageName}
          </Text>
        </Flex>
        <Pill bg={crm.surface} color={crm.textMuted}>
          {stage.cards.length}
        </Pill>
      </Flex>

      <Flex flexDir="column" gap="12px" p="12px" overflowY="auto" flex="1" minH="120px">
        {stage.cards.map((card) => (
          <ProcessCard
            key={card.id}
            card={card}
            onDragStart={onDragStartCard}
            onClick={onCardClick}
          />
        ))}
        {stage.cards.length === 0 && (
          <Flex
            flex="1"
            flexDir="column"
            align="center"
            justify="center"
            color={crm.textFaint}
            fontSize="sm"
            gap="8px"
            minH="100px"
            opacity={0.7}
          >
            <FaInbox size={20} />
            <Text>Sem processos</Text>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};

export default ProcessColumn;
